export const PERMISSION_TYPES = {
  admin: "CUSTOMER_EDIT",
  accInfo: "GENERAL_VIEW",
  applyAndSign: "PAYMENT_INITIATE"
};
